import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RouteHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (userRole === "1") {
      if (location.pathname === "/" || !location.pathname.startsWith("/admin")) {
        navigate("/admin/dashboard", { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return null;
};

export default RouteHandler;